import Link from 'next/link';
import LandingPageHero from './LandingPageHero'
import Container from 'react-bootstrap/Container'
import Card from 'react-bootstrap/Card'

export default function LandingPageContainer({page, children}) {
  const showBreadcrumbs = page.cachedDepth > 0
  const sortedAncestors = page.ancestors.sort((a, b) => (a.cachedDepth - b.cachedDepth))
  const linkPath = (ancestor) => {
    switch(ancestor.slug) {
      case 'subjects': return '/subjects';
      case 'locations': return '/locations';
      default: return `/tutoring/${ancestor.slug}`;
    }
  }

  return (
    <div>
      <LandingPageHero page={page} />
      <Container className="pt-lg-4">
        {showBreadcrumbs &&
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb bg-transparent px-0" itemScope itemType="https://schema.org/BreadcrumbList">
              {sortedAncestors.map(ancestor => (
                <li className="breadcrumb-item" itemProp="itemListElement" itemScope
                    itemType="https://schema.org/ListItem" key={ancestor.id}>
                  <Link
                    href={linkPath(ancestor)}
                    passHref
                    itemProp="item"
                    className="text-decoration-none"
                  >
                    <span itemProp="name">{ancestor.linkTitle}</span>
                    <meta itemProp="position" content={ancestor.cachedDepth + 1} />
                  </Link>
                </li>
              ))}
              <li className="breadcrumb-item active" aria-current="page" itemProp="itemListElement" itemScope
                  itemType="https://schema.org/ListItem">
                <span itemProp="name">{page.linkTitle}</span>
                <meta itemProp="position" content={page.cachedDepth + 1}/>
              </li>
            </ol>
          </nav>
        }

        {page.body1Text &&
          <Card className="mb-5">
            <Card.Body>
              <div dangerouslySetInnerHTML={{ __html: page.body1Text }}></div>
            </Card.Body>
          </Card>
        }

        {page.children &&
          <section className="mb-4">
            {page.children.map(child => (
              (<Link
                href={`/tutoring/${child.slug}`}
                passHref
                key={child.id}
                className="badge bg-secondary fw-normal text-decoration-none p-2 me-2 mb-2"
              >
                {child.linkTitle}
              </Link>)
            ))}
          </section>
        }

        {children}

        {page.body2Text &&
          <Card className="mb-5">
            <Card.Body>
              <div dangerouslySetInnerHTML={{ __html: page.body2Text }}></div>
            </Card.Body>
          </Card>
        }
      </Container>
    </div>
  )
}
